import React from 'react';
import Header from '../Header';
import Searchbox from '../SearchBox';
import HeadLine from '../HeadLine';
import HeroImage from '../HeroImage';
import Jumbotron from '../Jumbotron';

const HeroContent = () => (
  <header role="banner">
    <Header />
    <HeroImage>
      <Jumbotron>
        <HeadLine />
        <Searchbox />
      </Jumbotron>
    </HeroImage>
  </header>
);

export default HeroContent;
